<template>
  <svg :width="width" :height="height" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.7273 12.0455H7.95455V10.6818H12.7273V12.0455ZM14.7727 9.31818H7.95455V7.95455H14.7727V9.31818ZM14.7727 6.59091H7.95455V5.22727H14.7727V6.59091ZM16.1364 2.5H6.59091C5.83409 2.5 5.22727 3.10682 5.22727 3.86364V13.4091C5.22727 14.1659 5.84091 14.7727 6.59091 14.7727H16.1364C16.8932 14.7727 17.5 14.1659 17.5 13.4091V3.86364C17.5 3.10682 16.8864 2.5 16.1364 2.5ZM3.86364 5.22727V16.1364H14.7727V17.5H3.86364C3.50198 17.5 3.15513 17.3563 2.8994 17.1006C2.64367 16.8449 2.5 16.498 2.5 16.1364V5.22727H3.86364Z" :fill="iconColor"/>
  </svg>
  </template>
  
  <script>
  export default {
    props: {
      iconName: {
        type: String,
        default: "iconAccountDetail",
      },
      width: {
        type: [Number, String],
        default: 20,
      },
      height: {
        type: [Number, String],
        default: 20,
      },
      iconColor: {
        type: String,
        default: "currentColor",
      },
    },
  };
  </script>
  